import TimerReportedField from "./time-reported";

export default class TimeReportedFieldHours extends TimerReportedField {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.TIME_REPORTED_HOURS
        this.formulaCompatible = false;
    }

    getCsvValue(item) {
        let res = item.reportedTime;
        if (res) res = gd.utils.Time.roundHours(res);
        return res;
    }
}